exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mm-button[data-v-3fa8dcfe]{background:transparent;cursor:pointer;color:#1f1f1f;margin:0.16rem auto 0 auto}.mm-button .asset-img[data-v-3fa8dcfe]{height:0.19rem;position:relative;top:0.01rem}.mm-logo[data-v-3fa8dcfe]{height:0.2rem;margin-right:0.1rem}.mm-text[data-v-3fa8dcfe]{position:relative;top:0.02rem}\n", ""]);

// exports
